import { useId, useRef } from 'react';
import { useModalFocus } from '../hooks/useModalFocus';

export function ConfirmationDrawer({ isOpen, onCancel, onConfirm, title, message, confirmLabel = 'Delete' }) {
  const panelRef = useRef(null);
  const titleId = useId();
  const messageId = useId();
  // Focus lands on the first button (Cancel), the safe choice for a destructive confirmation.
  useModalFocus({ isOpen, panelRef, onClose: onCancel });

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/30 z-40 transition-opacity"
        onClick={onCancel}
        aria-hidden="true"
      />
      
      {/* Drawer */}
      <div
        ref={panelRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        tabIndex={-1}
        className="fixed bottom-0 left-0 right-0 bg-card text-foreground rounded-t-3xl z-50 animate-slide-up max-w-[600px] mx-auto shadow-[0_-8px_24px_rgba(0,0,0,0.08)] focus:outline-none"
      >
        <div className="p-6">
          {/* Title */}
          <h2 id={titleId} className="text-center mb-2">{title}</h2>
          
          {/* Message */}
          <p id={messageId} className="text-center text-muted-foreground mb-6">{message}</p>
          
          {/* Buttons */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 py-3 rounded-full border-2 border-[#5F6B3F] text-[#5F6B3F] font-medium bg-white hover:bg-[#F0F3EC] transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                onConfirm();
              }}
              className="flex-1 py-3 rounded-full bg-[var(--destructive)] text-[var(--destructive-foreground)] hover:bg-[color-mix(in_srgb,_var(--destructive)_90%,_#000_10%)] transition-colors"
            >
              {confirmLabel}
            </button>
          </div>
        </div>
        
        {/* Safe area spacing for mobile */}
        <div className="h-[env(safe-area-inset-bottom)]" />
      </div>
    </>
  );
}
